import { Component, inject, OnInit, Signal, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { IGlobalElements } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/interfaces/global-elements.interface';
import { CurrentTenantService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/current-tenant.service';
import { GlobalElementsService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/global-elements.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DynamicRouteService } from '../../../../dynamic-routes';
import { STATIC_PUBLIC_TOOLBAR_LINKS } from './static-public-toolbar-links.constant';

@Component({
  standalone: false,
  selector: 'navigation-toolbar',
  templateUrl: './navigation-toolbar.component.html',
  styleUrls: ['./navigation-toolbar.component.scss'],
})
export class NavigationToolbarComponent implements OnInit {
  private readonly unsubscribe$ = new Subject<void>();

  protected readonly currentTenant = inject(CurrentTenantService).currentTenant;

  globalElements: Signal<IGlobalElements>;

  @ViewChild('sidenavContent') sidenavContent: MatSidenavContent;
  @ViewChild('drawer') drawer: MatSidenav;

  links = [];

  constructor(
    private readonly router: Router,
    private readonly dynamicRoutes: DynamicRouteService,
    private readonly globalElementsService: GlobalElementsService,
  ) {}

  ngOnInit() {
    this.initLinks();

    this.router.events
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      )
      .subscribe(() => this.drawer.close());

    this.globalElements = this.globalElementsService.globalElements;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private async initLinks() {
    this.links = (
      await this.dynamicRoutes.getLinks({
        treeType: 'public',
        includeTree: true,
      })
    )
      .filter((route) => route.displayName !== 'Home')
      .concat(STATIC_PUBLIC_TOOLBAR_LINKS);
  }

  homeClick() {
    this.router.navigateByUrl('/');
  }
}
